import React from "react";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { DataFinalArray } from "../../types/BMW";
import { Typography, Paper } from "@mui/material";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
);

interface Props {
  data: DataFinalArray[];
}

const EstimationPleinChart: React.FC<Props> = ({ data }) => {
  if (!data.length) return null;

  const chartData = {
    labels: data.map((d) =>
      d.date
        .toDate()
        .toLocaleDateString(undefined, { day: "numeric", month: "numeric" }),
    ),
    datasets: [
      {
        label: "Estimation plein",
        data: data.map((d) => d.pleinEstimation),
        tension: 0.3,
        fill: false,
        borderColor: "blue", // ← ligne blanche
        backgroundColor: "blue", // ← si tu veux remplir sous la ligne (ici non)
        pointBackgroundColor: "blue", // ← points blancs
        pointBorderColor: "blue",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "white",
        },
      },
    },
    scales: {
      x: {
        ticks: { color: "white" },
        grid: { color: "#333" },
      },
      y: {
        min: 300, // ← valeur minimale
        max: 550, // ← valeur maximale
        ticks: { color: "white" },
        grid: { color: "#333" },
      },
    },
  };

  return (
    <Paper sx={{ mt: 4, p: 3, backgroundColor: "#1e1e1e" }}>
      <Typography variant="h6" gutterBottom sx={{ color: "white" }}>
        Estimation plein
      </Typography>
      <Line data={chartData} options={options} />
    </Paper>
  );
};

export default EstimationPleinChart;
